module.exports = "/packs/chevron-right-white-00f342be248d545260690abc6e7cae0e.svg";